import { render, staticRenderFns } from "./InvoiceItem.vue?vue&type=template&id=736360b8&scoped=true&"
import script from "./InvoiceItem.vue?vue&type=script&lang=ts&"
export * from "./InvoiceItem.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceItem.vue?vue&type=style&index=0&id=736360b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736360b8",
  null
  
)

export default component.exports